import type { CheckboxSelectionCallbackParams, ColDef, GridOptions, IRowNode } from 'ag-grid-community';

import { TextButtonCell } from '~/components/common';
import { ManagerNameCellRenderer } from '~/components/vender';

import type { TypeOwnerManagerDetail } from '~/types/vender.types';

/**
 * [화주사 정보 관리 > 화주사 정보] '담당자 정보' 테이블
 */
const getVenderConfirmManagerInfoColumnDefs = ({
  hasEditPermission,
  onClickManagerModify,
}: {
  hasEditPermission: boolean;
  onClickManagerModify: (node: IRowNode<TypeOwnerManagerDetail>) => void;
}) => {
  const gridOptions: GridOptions = {
    defaultColDef: {
      minWidth: 49,
    },
    isRowSelectable: (params: IRowNode<TypeOwnerManagerDetail>) => {
      return params.rowIndex !== 0;
    },
    rowClassRules: {
      'ag-row-disabled': (params) => params.rowIndex === 0,
    },
  };

  const columnDefs: ColDef<TypeOwnerManagerDetail>[] = [
    {
      headerName: '',
      width: 72,
      valueFormatter: () => '',
      headerCheckboxSelection: hasEditPermission,
      checkboxSelection: (params: CheckboxSelectionCallbackParams<TypeOwnerManagerDetail>) => {
        return hasEditPermission && params.node && params.node.rowIndex !== 0;
      },
      showDisabledCheckboxes: true,
    },
    {
      field: 'ownerLoginId',
      headerName: '아이디',
      width: 200,
      cellRenderer: ManagerNameCellRenderer,
    },
    {
      field: 'ownerManagerName',
      headerName: '담당자명',
      width: 140,
    },
    {
      field: 'ownerManagerPosition',
      headerName: '직위',
      width: 120,
    },
    {
      field: 'ownerManagerTel',
      headerName: '휴대폰번호',
      width: 140,
    },
    {
      field: 'ownerManagerEmail',
      headerName: '이메일',
      width: 288,
      flex: hasEditPermission ? undefined : 1,
    },
    {
      headerName: '',
      minWidth: 107,
      flex: 1,
      hide: !hasEditPermission,
      cellRenderer: TextButtonCell,
      cellRendererParams: {
        children: '수정',
        showDashIfNoValue: false,
        onClick: (node: IRowNode<TypeOwnerManagerDetail>) => onClickManagerModify(node),
      },
      cellStyle: { display: 'flex', alignItems: 'center' },
    },
  ];

  return { gridOptions, columnDefs };
};

export default getVenderConfirmManagerInfoColumnDefs;
